import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import meal from "./modules/meal";
import customer from "./modules/customer";
import order from "./modules/order";
import roboter from "./modules/roboter";
import setting from "./modules/setting";
import pdfTemplate from "./modules/pdfTemplate";
import mail from "./modules/mail";
import notification from "./modules/notification";
import mailTemplate from "./modules/mailTemplate";
import countries from "./modules/countries";
import { version } from "../../package.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    packageVersion: version || "0",
    appLoading: false
  },
  mutations: {
    SET_APP_LOADING(state, value) {
      state.appLoading = !!value;
    }
  },
  actions: {
    isCurrentDate(lastTimestamp) {
      let currentDate = new Date();
      let lastDate = new Date(lastTimestamp);

      return (
        currentDate.getFullYear() === lastDate.getFullYear() &&
        currentDate.getDate() === lastDate.getDate() &&
        currentDate.getMonth() === lastDate.getMonth()
      );
    }
  },
  getters: {
    appVersion(state) {
      return state.packageVersion;
    },
    appLoading(state) {
      return !!state.appLoading;
    }
  },
  modules: {
    user,
    meal,
    customer,
    order,
    roboter,
    setting,
    pdfTemplate,
    mailTemplate,
    mail,
    notification,
    countries
  }
});
